import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import { HUBMAILSERVICE } from '../utils/constants';
import { SentMail, ReceivedMail } from 'models/response';

/**
 * Get sent mails
 * @param {string} dateFrom
 * @param {string} dateTo
 * @return {Promise<AxiosResponse<SentMail[]>>}
 */
const getSentMail = (dateFrom: string, dateTo: string) =>
  trackPromise(
    axios.get<SentMail[]>(`${HUBMAILSERVICE}/sentMail`, {
      params: { dateFrom: dateFrom, dateTo: dateTo },
    }),
    'module',
  );

/** Get received mails
 * @param {string} dateFrom
 * @param {string} dateTo
 * @return {Promise<AxiosResponse<ReceivedMail[]>>}
 */
const getReceivedMail = (dateFrom: string, dateTo: string) =>
  trackPromise(
    axios.get<ReceivedMail[]>(`${HUBMAILSERVICE}/receivedMail`, {
      params: { dateFrom: dateFrom, dateTo: dateTo },
    }),
    'module',
  );

export default {
  getSentMail,
  getReceivedMail,
};
